import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
  imageFormatter,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getBlogs, deleteBlog, changeStatusBlog } from "../../../../api/blog";
import { Button, Tooltip, Switch, FormControlLabel } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";
import { getNonEmpty } from "../../../../utils/helpers";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  VerifiedUser,
} from "@material-ui/icons";

function getData(blogs) {
  let data = [];
  for (let i = 0; i < blogs.length; ++i) {
    const elem = {};
    elem.title = getNonEmpty(blogs[i].title);
    elem.image = blogs[i].imageUrl;
    elem.id = blogs[i]._id;
    elem.active = blogs[i].active;
    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {
  active: false,
};

export default function BlogsPage() {
  const [data, setData] = useState([]);
  const [blogId, setBlogId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [refreshOrder, setRefreshOrder] = useState(false);

  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);

    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-blog/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(user?.role === "admin" || user.role === "gestor") && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setBlogId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setBlogId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "title", text: "Titulo", sort: true },
    { dataField: "image", text: "Image", formatter: imageFormatter },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getBlogs();
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setRefresh(false);
        }
      } catch (error) {
        alertError({ error: error, customMessage: "Could not get blogs." });
        history.push("/dashboard");
      }
    };
    fetch();
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <>
        <br />
        <FormControlLabel
          control={
            <Switch
              checked={filterOptions.active}
              onChange={() =>
                setFilterOptions({
                  ...filterOptions,
                  active: !filterOptions.active,
                })
              }
              name="checkActive"
            />
          }
          label={filterOptions.active ? "Only active" : "All active/inactive"}
        />
      </>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista de blogs">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-blog")}
            >
              Add new
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
            handleSearch={handleSearch}
          />

          {!refresh && !refreshOrder && (
            <Table data={getData(data)} columns={columns} />
          )}

          <ConfirmDialog
            title={`Are you sure you want to ${
              blogId?.active ? "disable" : "enable"
            } this blog?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusBlog(blogId._id, !blogId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${blogId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `User type ${
                        blogId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      blogId?.active ? "disable" : "enable"
                    } blog.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this blog?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteBlog(blogId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Blog removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove blog.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
